package one.healthium.notifications.manager

data class Notification(
    val id: Int,
    val title: String,
    val body: String,
    val link: String? = null,
    val priority: NotificationPriority? = null,
    val imagePath: String? = null,
)

enum class NotificationPriority {
    Normal,
    High,
}
